var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0575 7.05752C11.5782 6.53682 12.4224 6.53682 12.9431 7.05752L20.9431 15.0575C21.4638 15.5782 21.4638 16.4224 20.9431 16.9431L12.9431 24.9431C12.4224 25.4638 11.5782 25.4638 11.0575 24.9431C10.5368 24.4224 10.5368 23.5782 11.0575 23.0575L18.1147 16.0003L11.0575 8.94313C10.5368 8.42244 10.5368 7.57822 11.0575 7.05752Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.268ab4f3f8cf307edf80cf0b2092dae2.svg";